import update from "immutability-helper";
import _ from "lodash/array";
import moment from "moment";

const initialState = {
  cities: [],
  city: {},
  meta: {
    total_pages: 1,
    current_page: 1,
    total_count: 1
  },
  fetchParams: {
    status: null,
    search: null,
    page: 1,
    limit: 15
  },
  errors: false,
  isLoading: false,
  isModalVisible: false
};

export default function(state = initialState, action) {
  switch (action.type) {
    case "FETCH_CITIES_REQUEST":
      return {
        ...state,
        isLoading: true
      };
    case "FETCH_CITIES":
      return {
        ...state,
        cities: action.response.data,
        meta: action.response.meta,
        isLoading: false
      };
    case "FETCH_CITY_REQUEST":
      return {
        ...state,
        isLoading: true
      };
    case "FETCH_CITY":
      return {
        ...state,
        city: action.response.data,
        isLoading: false,
        isModalVisible: true
      };
    case "PATCH_CITY_REQUEST":
      return {
        ...state,
        isLoading: true
      };
    case "PATCH_CITY":
      return {
        ...state,
        city: action.response.data,
        isLoading: false,
        isModalVisible: false
      };

    case "POST_CITY_REQUEST":
      return {
        ...state,
        isLoading: true
      };
    case "POST_CITY":
      return {
        ...state,
        errors: false,
        city: {},
        isLoading: false,
        isModalVisible: false
      };

    case "POST_CITY_FAILURE":
      return {
        ...state,
        errors: true,
        isLoading: false
      };

    case "CITY_ADD":
      return {
        ...state,
        city: {
          name: null
        },
        errors: false,
        isLoading: false,
        isModalVisible: true
      };

    case "DELETE_CITY_REQUEST":
      return {
        ...state,
        isLoading: true
      };

    case "DELETE_CITY":
      return {
        ...state,
        isLoading: false
      };
    case "DELETE_CITY_FAILURE":
      return {
        ...state,
        isLoading: false
      };
    case "REQUEST_CITY_SEARCH":
      return update(state, {
        fetchParams: { search: { $set: action.value } }
      });

    case "REQUEST_CITY_CHANGE_PAGE":
      return update(state, {
        fetchParams: { page: { $set: action.value } }
      });

    case "CITY_TOGGLE_VISIBLE":
      return {
        ...state,
        isModalVisible: !state.isModalVisible
      };

    case "CITY_CHANGE_NAME":
      return update(state, {
        city: {
          name: { $set: action.value }
        }
      });

    case "CITY_CHANGE_STATE":
      return update(state, {
        city: {
          state: { $set: action.value }
        }
      });

    case "CITY_CHANGE_CITY_TYPE":
      return update(state, {
        city: {
          city_type: { $set: action.value }
        }
      });

    case "CITY_CHANGE_LAT":
      return update(state, {
        city: {
          lat: { $set: action.value }
        }
      });

    case "CITY_CHANGE_LON":
      return update(state, {
        city: {
          lon: { $set: action.value }
        }
      });

    case "CITY_CHANGE_FIAS":
      return update(state, {
        city: {
          fias_id: { $set: action.value }
        }
      });

    case "CITY_CHANGE_KLADR":
      return update(state, {
        city: {
          kladr_id: { $set: action.value }
        }
      });

    default:
      return state;
  }
}
